/** Additional German strings — merged into de locale */
const deExt = {
  reviewHub: {
    title: "Review Hub",
    subtitle: "Antworten, kritische Bewertungen priorisieren und Entfernungen beantragen — alles an einem Ort.",
    syncReviews: "Bewertungen synchronisieren",
    syncing: "Synchronisiere…",
    noProfile: "Kein verbundenes Profil",
    noProfileHint: "Verbinden Sie Google Business, um Bewertungen zentral zu verwalten.",
    connectPlatform: "Plattform verbinden",
    profile: "Profil",
    loadError: "Bewertungen konnten nicht geladen werden.",
    syncSuccess: "Synchronisation erfolgreich abgeschlossen.",
    syncFailed: "Synchronisation fehlgeschlagen.",
    replyFailed: "Antwort konnte nicht gesendet werden.",
    deselectAll: "Alle abwählen",
    selectAllVisible: "Alle sichtbaren auswählen",
    noCritical: "Keine kritischen Bewertungen",
    allCaughtUp: "Alles erledigt",
    everyReviewReplied: "Jede Bewertung hat eine Antwort.",
    nothingHurtingRating: "Nichts belastet Ihr Rating derzeit.",
    noReviewsToShow: "Keine Bewertungen anzuzeigen.",
    viewDeletionCases: "Löschfälle anzeigen",
    previous: "Zurück",
    next: "Weiter",
    pageOf: "Seite {{page}} von {{total}}",
    caseSubmitted: "Fall {{caseId}} erfolgreich eingereicht.",
    justNow: "Gerade eben",
    hoursAgo: "vor {{hours}} Std.",
    oneDayAgo: "vor 1 Tag",
    daysAgo: "vor {{days}} Tagen",
    highRisk: "Hohes Risiko",
    needsReply: "Antwort erforderlich",
    criticalHint: "Antworten Sie zuerst oder beantragen Sie eine Entfernung, wenn Richtlinien verletzt wurden.",
    noReviewText: "Kein Bewertungstext.",
    seeMore: "Mehr anzeigen",
    seeLess: "Weniger anzeigen",
    yourResponse: "Ihre Antwort",
    replyQueued: "Antwort in Warteschlange — wird an Google gesendet…",
    jamedaReplyUnavailable: "Antworten auf Jameda bald verfügbar",
    sendResponse: "Antwort senden",
    sending: "Senden…",
    selectForRemoval: "Zur Entfernung auswählen",
    deselectForRemoval: "Aus Entfernungsauswahl entfernen",
    allVisibleInDeletionCase:
      "Alle sichtbaren kritischen Bewertungen sind bereits in einem Löschfall.",
    caseSuccessLink: "Löschfälle anzeigen",
  },
  metrics: {
    reviewsTotal: "Gesamt",
    reviewsTotalHint: "Alle importierten Bewertungen",
    reviewsAverage: "Durchschnitt",
    reviewsAverageHint: "Aktueller Profil-Durchschnitt",
    reviewsNewToday: "Heute neu",
    reviewsNewTodayHint: "Neu synchronisiert heute",
    reviewsCritical: "Kritisch (≤3★)",
    reviewsCriticalHint: "Benötigt Aufmerksamkeit",
    casesTotal: "Fälle gesamt",
    casesTotalHint: "Alle eingereichten Anträge",
    casesPending: "Ausstehend",
    casesPendingHint: "Warten auf Erstprüfung",
    casesInProgress: "In Bearbeitung",
    casesInProgressHint: "Rechtliche Prüfung",
    casesCompleted: "Abgeschlossen",
    casesCompletedHint: "Erfolgreich entfernt",
    casesRejected: "Abgelehnt",
    casesRejectedHint: "Einspruch möglich",
    casesNewThisMonth: "+{{count}} diesen Monat",
  },
  billing: {
    title: "Pläne & Abrechnung",
    statusLabel: "Status: {{status}}",
    starter: "Starter",
    freeTier: "Kostenlos",
    currentPlan: "Aktueller Tarif",
    mostPopular: "Am beliebtesten",
    professional: "Premium",
    basicPlan: "Basic",
    premiumPlan: "Premium",
    basicTagline: "Alles aus Ihrer kostenlosen Testphase — ohne zeitliche Begrenzung",
    chooseBasic: "Basic wählen",
    upgradeProfessional: "Auf Premium upgraden",
    enterprise: "Enterprise",
    contactSales: "Vertrieb kontaktieren",
    planComparison: "Tarifvergleich",
    ctaTitle: "Bereit, Ihre globale Reputation zu sichern?",
    ctaSubtitle: "Upgraden Sie auf Premium für monatliche Löschungen und Prioritäts-Support.",
    goToPayment: "Zur Zahlung",
    activeCases: "Aktive Fälle",
    startNewCase: "Neuen Löschfall starten",
    selectReviews: "Bewertungen auswählen",
    volumePricing: "Volumenbasierte Preise",
    perEach: "/Stk.",
    freeTierButton: "Kostenlos",
    monthly: "/Monat",
    billedMonthly: "Monatliche Abrechnung",
    featureBillingModel: "Abrechnungsmodell",
    featureReviewSelection: "Bewertungsauswahl",
    featureIncludedDeletions: "Enthaltene Löschungen",
    featurePricePerReview: "Preis pro Bewertung",
    featureSupportLevel: "Support-Level",
    featureReporting: "Berichte",
    freeBilling: "Pro Bulk-Löschung",
    proBilling: "Feste Monatsgebühr",
    entBilling: "Individuelle Vereinbarung",
    freeSelection: "Bulk-Löschfälle",
    proSelection: "Flexibel — nach Bedarf",
    entSelection: "Flexibel — alle Standorte",
    freeIncluded: "Keine — pro Bewertung",
    proIncluded: "2 kostenlose Fälle pro Monat",
    entIncluded: "Individuelles Kontingent",
    freePrice: "Volumenbasiert (ab €79)",
    proPrice: "€79 (nach Inklusivkontingent)",
    entPrice: "Auf Anfrage",
    freeSupport: "Nur Dokumentation",
    proSupport: "24h Prioritäts-Support",
    entSupport: "Persönlicher Ansprechpartner",
    freeReporting: "Monatliche Basis-Zusammenfassung",
    proReporting: "Echtzeit-Statusupdates",
    entReporting: "Echtzeit + individuelle Reports",
    freeFeature1: "Basis-Bewertungsüberwachung",
    freeFeature2: "Keine monatlichen Löschungen inklusive",
    freeFeature3: "Nur manuelle Falleinreichung",
    proFeature1: "2 kostenlose Löschungen pro Monat",
    proFeature2: "Reduzierter Satz: €79 / Fall",
    proFeature3: "Erweiterte Plattform-Synchronisation",
    proFeature4: "Prioritäts-Support",
    proFeature5:
      "Negative Bewertungen per Klick auswählen und den Löschprozess direkt anstoßen",
    proFeature6: "Bewertungen direkt aus dem Dashboard heraus beantworten",
    proFeature7:
      "Integriertes Bewertungsmonitoring mit Benachrichtigungen über neue Rezensionen (Plattformübergreifend: Google, GoLocal, Kununu & Co.)",
    proFeature8:
      "Automatisiertes Einholen positiver Bewertungen über ein E-Mail-Feedback-System",
    proFeature9: "Business Network (Vernetzung mit Unternehmen aus unserem Netzwerk)",
    entFeature1: "Unbegrenzt viele Standorte je Plattform verbinden (Google, Jameda usw.)",
    entFeature2: "Alles aus dem Premium-Tarif enthalten",
    entFeature3: "Individuelle Konditionen & Löschkontingente",
    entFeature4: "Persönlicher Ansprechpartner & bevorzugter Support",
    scale: "Skalierung",
    enterprisePlan: "Enterprise",
    individualPrice: "Individuell",
    enterpriseTagline:
      "Für Ketten, Gruppen und Agenturen mit mehreren Standorten — Preis auf Anfrage.",
    oneLocation: "1 Standort pro Plattform verbindbar (Google, Jameda usw.)",
    oneLocationShort: "1 pro Plattform",
    unlimitedLocations: "Unbegrenzt viele — je Plattform",
    featureLocations: "Verbundene Standorte",
    trialNoteTitle: "3 Tage kostenlos testen — mit allen Funktionen",
    trialNote:
      "Während der Testphase können Sie unbegrenzt viele Standorte je Plattform verbinden und alle Funktionen nutzen. Nach 3 Tagen wählen Sie einfach den passenden Tarif.",
    band1: "1–5 Bewertungen",
    band2: "6–10 Bewertungen",
    band3: "11+ Bewertungen",
    growth: "Growth",
    architect: "Architect",
    custom: "Individuell",
    proTagline: "Optimal für wachsende Unternehmen",
    entTagline: "Hochvolumige Unternehmenslösung",
    comparisonDesc: "Detaillierter Funktionsvergleich für Entscheider.",
    featureColumn: "Funktion",
    paidDesc:
      "Ihr Premium-Tarif umfasst monatliche Löschkontingente, reduzierte Fallpreise und Prioritäts-Support.",
    unpaidDesc:
      "Wählen Sie Basic (79 €/Monat), um Ihre Testphasen-Funktionen zu behalten, oder Premium (179 €/Monat) für niedrigere Preise pro Bewertung, monatliche Inklusiv-Löschungen und erweiterte Berichte.",
    includedOf: "/ {{count}} inklusive",
    freeDeletionsRemaining:
      "Sie haben noch {{count}} kostenlose Löschung(en) in Ihrer aktuellen 30-Tage-Periode. Weitere Entfernungen kosten geschätzt {{price}} pro Bewertung (manuell abgerechnet).",
  },
  subscription: {
    professionalBenefitsTitle: "Professional-Tarif Vorteile",
    freeRemainingBanner: "{{remaining}} von {{allowance}} kostenlosen Löschungen übrig",
    freeUsedThisPeriod: "{{count}} in dieser Periode bereits genutzt",
    periodEnds: "Aktuelle Periode endet am {{date}} — danach erneuert sich das Kontingent.",
    resetsOn: "Kontingent erneuert sich am {{date}}",
  },
  payment: {
    backToDashboard: "Zurück zum Dashboard",
    secureCheckout: "Sicherer Checkout",
    checkout: "Checkout",
    paymentHistory: "Zahlungshistorie",
    noPayments: "Noch keine Zahlungen",
    paymentMethod: "Zahlungsmethode",
    privacyPolicy: "Datenschutz",
    termsOfService: "Nutzungsbedingungen",
    afterPaymentHint: "Nach der Zahlung kehren Sie zu den Bewertungen zurück, um Ihren Löschfall einzureichen.",
    processing: "Wird verarbeitet…",
    orderSummary: "BESTELLÜBERSICHT",
    included: "Inklusive",
    totalDue: "Gesamtbetrag",
    billedMonthlyCancel:
      "Verlängert sich automatisch jeden Abrechnungszeitraum, bis Sie kündigen.",
    secureSsl: "Sicherer Checkout — SSL-verschlüsselt",
    vatInvoice: "MwSt.-Rechnung nach Zahlung verfügbar",
    needAssistance: "Hilfe benötigt?",
    contactSupport: "Support kontaktieren",
    cardholderRequired: "Name des Karteninhabers ist erforderlich.",
    cardholderName: "KARTENINHABER",
    cardholderPlaceholder: "z. B. Max Mustermann",
    cardNumberInvalid: "Geben Sie eine gültige Kartennummer ein.",
    expiryDate: "GÜLTIG BIS",
    expiryFormat: "Format MM/JJ verwenden.",
    cardEncrypted: "Ihre Kartendaten werden an der Quelle verschlüsselt und nie auf unseren Servern gespeichert.",
    payWithCard: "{{amount}} mit Karte zahlen",
    paypalEmailRequired: "Geben Sie die mit Ihrem PayPal-Konto verknüpfte E-Mail ein.",
    paypalRedirect: "Nach Bestätigung werden Sie zu PayPal weitergeleitet, um die Zahlung abzuschließen.",
    paypalEmail: "PAYPAL-E-MAIL",
    continuePaypal: "Weiter zu PayPal — {{amount}}",
    sepaNameRequired: "Name des Kontoinhabers ist erforderlich.",
    sepaIbanInvalid: "Geben Sie eine gültige IBAN ein (ohne Leerzeichen).",
    sepaMandateRequired: "Sie müssen das SEPA-Lastschriftmandat autorisieren.",
    sepaHint: "Zahlung von Ihrem EU-Bankkonto per SEPA-Lastschrift.",
    sepaBicHint: "Erforderlich für einige Nicht-DE-Konten.",
    sepaMandate: "Ich autorisiere ein SEPA-Lastschriftmandat für {{amount}} an ReviewLytics GmbH.",
    paySepa: "{{amount}} per SEPA zahlen",
    paymentSuccessful: "Zahlung erfolgreich",
    paymentSuccessBody:
      "Ihr Professional-Tarif ist aktiv. Das Abo verlängert sich automatisch monatlich. Weiterleitung…",
    methodCard: "Kreditkarte",
    methodCardDesc: "Visa, Mastercard, Amex",
    methodPaypal: "PayPal",
    methodPaypalDesc: "Mit Guthaben oder Bank zahlen",
    methodSepa: "SEPA-Lastschrift",
    methodSepaDesc: "EU-Banküberweisung",
    subscriberTitle: "Premium-Tarif",
    basicTitle: "Basic-Tarif",
    basicSubtitle: "79 €/Monat — monatliche Abrechnung mit automatischer Verlängerung",
    basicPlanLine: "Basic-Tarif (monatlich)",
    subscriberSubtitle: "179 €/Monat — monatliche Abrechnung mit automatischer Verlängerung",
    subscriberPlanLine: "Professional-Tarif (monatlich)",
    includedDeletionsLine: "Enthaltene Bewertungslöschungen",
    deletionsAllowance: "{{count}} Löschungen pro Monat",
    deletionPaymentTitle: "Zahlung für Bewertungslöschung",
    deletionBulk: "{{count}} Bewertung(en) — Bulk-Löschfall",
    deletionLine: "Bewertungslöschung — {{tier}}",
    deletionLineGeneric: "Bewertungslöschung (Bulk-Fall)",
    deletionSubtitle: "{{count}} Bewertung(en) in dieser Einreichung",
    checkoutSubtitle:
      "Gewählten Tarif abonnieren (automatische monatliche Verlängerung). Löschfälle und andere manuelle Leistungen werden separat in Rechnung gestellt.",
    subscriptionOnlyNote:
      "Diese Kasse gilt nur für Ihr Monatsabo. Löschkosten werden in der App geschätzt und außerhalb der Plattform manuell abgerechnet.",
    stripeCheckoutTitle: "Mit Stripe abonnieren",
    stripeCheckoutDesc:
      "Sie schließen die Zahlung auf der sicheren Stripe-Checkout-Seite ab. Wir speichern keine Kartendaten.",
    stripeRedirectNote:
      "Klicken Sie unten, um Stripe Checkout zu öffnen. Karte und SEPA-Lastschrift sind je nach Region verfügbar.",
    stripeRenewalNote:
      "{{amount}} pro Monat — verlängert sich automatisch, bis Sie kündigen.",
    stripeMethodsNote: "Zahlung per Kreditkarte oder SEPA-Lastschrift (über Stripe).",
    stripeSecureNote: "PCI-konformer Checkout — Zahlungsdaten bleiben bei Stripe.",
    subscribeNow: "Abonnieren — {{amount}}/Monat",
    stripePowered: "Zahlungen werden sicher über Stripe abgewickelt.",
    paymentNotConfigured: "Online-Checkout wird eingerichtet",
    paymentNotConfiguredHint:
      "Stripe ist noch nicht verbunden. Bitte kontaktieren Sie den Support oder versuchen Sie es erneut, sobald die Zahlung freigeschaltet ist.",
    alreadySubscribed: "Sie nutzen den Professional-Tarif",
    alreadySubscribedHint:
      "Ihr Abo ist aktiv und verlängert sich automatisch jeden Monat.",
    manageBilling: "Abrechnungsdetails ansehen",
    checkoutCancelled: "Checkout abgebrochen. Sie können es jederzeit erneut versuchen.",
    verifyPaymentFailed:
      "Zahlung konnte nicht bestätigt werden. Bitte kontaktieren Sie den Support, falls abgebucht wurde.",
    verifyingPayment: "Zahlung wird bestätigt…",
    checkoutStartFailed:
      "Checkout konnte nicht gestartet werden. Bitte erneut versuchen oder Support kontaktieren.",
    completedPayments: "Abgeschlossene Zahlungen erscheinen hier.",
    goToCheckout: "Zum Checkout",
    allEncrypted: "Alle Zahlungsoptionen sind vollständig verschlüsselt und sicher.",
    support24: "Unser Enterprise-Support ist rund um die Uhr für Checkout-Fragen erreichbar.",
    footerCopyright:
      "© 2026 ReviewLytics. Sicherer Checkout.",
    afterPaymentReturn: "Nach der Zahlung kehren Sie zu",
    afterPaymentSubmit: "zurück, um Ihren Löschfall einzureichen.",
    cardNumber: "KARTENNUMMER",
    cvc: "CVC",
    securityCodeRequired: "Geben Sie den Sicherheitscode ein.",
    accountHolder: "KONTOINHABER",
    accountHolderPlaceholder: "Firma oder Name",
    iban: "IBAN",
    bicOptional: "BIC (OPTIONAL)",
    sepaMandateRecurring: "jeden Monat, bis ich mein Abo kündige.",
    sepaMandateOneTime: "für diese einmalige Zahlung.",
    sepaMandateRefund:
      "Ich kann innerhalb von 8 Wochen gemäß SEPA-Regeln eine Erstattung verlangen.",
    methodAria: "Zahlungsmethode",
    paypalPlaceholder: "sie@beispiel.de",
  },
  pricingPanel: {
    livePricing: "Live-Preise",
    tierProgress: "Tarif-Fortschritt",
    pricingByStatus: "Preise richten sich nach Ihrem Kontostatus.",
    successRate: "Aktuelle Erfolgsquote: 93%",
    freeTier: "Kostenlos",
    subscriber: "Subscriber",
    selectedReviews: "Ausgewählte Bewertungen",
    pricePerReview: "Preis pro Bewertung",
    estimatedTotalThisCase: "Geschätzte Summe (dieser Fall)",
    totalThisCase: "Summe (dieser Fall)",
    continueToCase: "Weiter zu Falldetails",
    manualInvoicingNote:
      "Die angegebenen Löschkosten dienen lediglich der Orientierung. Berechnet werden ausschließlich erfolgreich entfernte Bewertungen. Die Rechnung erhalten Sie nach Abschluss der Löschungen gesondert per E-Mail.",
    clearSelection: "Auswahl löschen",
    freeRemaining: "{{count}} kostenlose Löschung(en) übrig",
    estimatedTotal: "Geschätzte Summe",
    activePackage: "Aktives Paket:",
    savingsVs: "Sie sparen {{amount}} gegenüber der €129-Stufe bei diesem Batch",
    bulkNote:
      "Alle ausgewählten Bewertungen werden gemeinsam in einem Bulk-Fall eingereicht. Preise aktualisieren sich beim Hinzufügen.",
    freeThisMonth: "Kostenlos diesen Monat (übrig)",
    freeAppliedLabel: "Kostenlos auf Auswahl angewendet",
    paidReviews: "Kostenpflichtige Bewertungen",
    perPaidReview: "Pro kostenpflichtiger Bewertung",
    caseTotal: "Gesamtbetrag Fall",
    planBilled: "Tarif: {{amount}}/Mo. (Abo separat abgerechnet)",
    submissionSummary:
      "{{freeApplied}} kostenlos + {{paidCount}} kostenpflichtig = {{total}} für diese Einreichung",
    freeAppliedHighlight: "{{count}} Bewertung(en) in diesem Fall kostenlos enthalten",
    freeAppliedDetail:
      "Automatisch aus Ihrem Professional-Kontingent (2 kostenlose Löschungen alle 30 Tage).",
    noFreeRemaining:
      "Keine kostenlosen Löschungen mehr in dieser 30-Tage-Periode. Weitere Bewertungen zum kostenpflichtigen Tarif geschätzt.",
    subscriberPlan: "Subscriber-Tarif",
    billingPlanAria: "Abrechnungstarif",
    livePricingAria: "Live-Preise",
    ratingImpact: "Auswirkung auf Bewertung",
    currentRating: "Aktuell",
    afterDeletion: "Nach Löschung",
    ratingImpactHint: "Wählen Sie Bewertungen aus, um Ihre neue Bewertung zu sehen.",
    ratingImpactBasedOn: "Basierend auf {{count}} Bewertungen dieses Profils.",
  },
  documentation: {
    featured: "Empfohlen",
    minRead: "{{minutes}} Min. Lesezeit",
    defamationDesc: "Erkennen Sie Bewertungen mit falschen Tatsachenbehauptungen, die zur Entfernung infrage kommen.",
    replyDesc: "Professionelle und freundliche Antwortvorlagen für jeden Bewertungstyp.",
    deletionDesc: "Schritt-für-Schritt-Anleitung von der Auswahl bis zur rechtlichen Klärung.",
    googlePoliciesDesc: "Plattformregeln zu Spam, Interessenkonflikten und verbotenen Inhalten.",
    ratingImpactDesc: "Wie kritische Bewertungen Ihren Durchschnitt und Ihr Profil beeinflussen.",
    reviewCritical: "Kritische Bewertungen prüfen",
    articleDefamation: "Leitfaden Verleumdung",
    articleReply: "Antwort-Best Practices",
    articleDeletion: "Löschfall-Prozess",
    articleGoogle: "Google-Bewertungsrichtlinien",
    articleRating: "Rating-Auswirkung verstehen",
  },
  signup: {
    stepPersonal: "Persönliche Daten",
    stepCompany: "Unternehmensdaten",
    journeyTitle: "Beginnen Sie Ihre Reise",
    journeySubtitle: "Erstellen Sie Ihr Konto in zwei einfachen Schritten.",
    fullNameLabel: "Vollständiger Name",
    nextCompany: "Weiter: Unternehmensdaten",
    haveAccount: "Haben Sie bereits ein Konto?",
    completeRegistration: "Registrierung abschließen",
    consentRegistration: "Mit der Registrierung stimmen Sie unseren",
    processingTitle: "Profil wird erstellt…",
    processingSubtitle: "Anmeldedaten werden überprüft…",
    systemIntegrity: "SYSTEMINTEGRITÄT",
    stepEmail: "E-MAIL WIRD ÜBERPRÜFT",
    stepSecurity: "SICHERHEITSSCHLÜSSEL WERDEN GENERIERT",
    stepSetup: "KONTOEINRICHTUNG WIRD ABGESCHLOSSEN",
    successTitle: "Dein Konto ist bereit!",
    successSubtitle: "Willkommen in der Zukunft des digitalen Präsenzmanagements.",
    adminRegisterTitle: "Neuen Benutzer registrieren",
    adminRegisterSubtitle: "Gleicher Ablauf wie die öffentliche Registrierung — Admin legt das Konto an.",
    userRegistered: "{{name}} ({{email}}) wurde registriert.",
    registering: "Registriere…",
  },
  adminHome: {
    title: "Admin-Dashboard",
    subtitle: "Übersicht aller Löschfälle, Benutzer und Plattformaktivitäten.",
    overview: "Plattformübersicht",
    platformAdmin: "Plattform-Admin",
    analyticsTitle: "Löschfälle — Analytics",
    viewAllCases: "Alle Fälle anzeigen",
    viewAllUsers: "Alle Benutzer anzeigen",
    manageCases: "Löschfälle verwalten",
    manageCasesDesc: "Anträge prüfen, Ergebnisse markieren und Fälle abschließen.",
    usersCard: "Benutzer",
    usersDesc: "Konten registrieren, Rollen und Impersonation.",
    actionCases: "Fälle verwalten",
    actionCasesDesc: "Löschanträge prüfen und Ergebnisse aktualisieren.",
    actionUsers: "Benutzerverwaltung",
    actionUsersDesc: "Konten suchen, Rollen ändern, Kunden impersonieren.",
    actionAlerts: "E-Mail-Benachrichtigungen",
    actionAlertsDesc: "Admin-Warnungen für Plattformereignisse konfigurieren.",
    actionDocs: "Betriebsdoku",
    actionDocsDesc: "Interne Anleitungen für Fallbearbeitung und Impersonation.",
    activeCasesLabel: "Aktive Fälle",
    activeCasesHint: "Ausstehende und laufende Löschanträge",
    workflowTitle: "Empfohlener Admin-Workflow",
    workflow1: "Neue Löschfälle überwachen und Ergebnisse je Bewertung setzen.",
    workflow2: "Impersonation nutzen, um Kunden im Dashboard zu unterstützen.",
    workflow3: "Rollen und Kontostatus mit der Abrechnung abgleichen.",
    opsGuideTitle: "Betriebshandbuch",
    opsGuideDesc: "Interne Anleitungen für Fallbearbeitung, Impersonation und Moderation.",
    readOpsDocs: "Betriebsdoku lesen",
  },
  adminCases: {
    title: "Löschfälle — Verwaltung",
    outcomeHint: "Bitte markieren Sie zuerst jede Bewertung als „Entfernt“ oder „Nicht entfernbar“, bevor Sie den Fall abschließen.",
    loading: "Lade Anträge…",
    noMatches: "Keine Anträge für diese Filter",
    totalRequests: "{{count}} Antrag/Anträge gesamt",
    searchPlaceholder: "Fall-ID, Name, E-Mail, Begründung…",
  },
  adminReviews: {
    title: "Bewertungen (Admin)",
    subtitle: "Bewertungsmoderation und Übersicht über alle Unternehmen.",
    companiesTracked: "Verfolgte Unternehmen",
    pendingModeration: "Ausstehende Moderation",
    flaggedWeek: "Diese Woche markiert",
    toolsTitle: "Admin-Bewertungstools",
    globalSearch: "Globale Bewertungssuche",
    searchPlaceholder: "Autor, Text, Firma, Standort…",
    loading: "Lade Bewertungen…",
    noReviews: "Keine Bewertungen gefunden",
    noReviewsHint: "Filter oder Suchbegriffe anpassen.",
    totalReviews: "{{count}} Bewertung(en) gesamt",
    unknownCompany: "Unbekanntes Unternehmen",
    openClientHub: "Kunden-Hub öffnen",
  },
  deletionCaseUi: {
    noReviewText: "Kein Bewertungstext",
    included: "Inkl.",
    reviewNumber: "Bewertung #{{id}}",
    reviewAria: "Bewertung {{id}} von {{author}}",
    pricingOverview: "Preisübersicht",
    caseTotal: "Gesamtbetrag Fall",
    package: "Paket",
    perReview: "Pro Bewertung",
    free: "Kostenlos",
    estimateHint: "Schätzung basierend auf aktuellem Paket und Auswahl.",
    caseSum: "Summe Fall",
    noReviews: "Keine Bewertungen",
    anonymous: "Anonym",
    moreReviews: "+{{count}} weitere",
    viewAll: "Alle anzeigen",
    reviewsForDeletion: "Bewertungen zur Löschung",
    reviewsInCase: "{{count}} Bewertung(en) in diesem Fall",
    noLinkedReviews: "Keine Bewertungen mit diesem Fall verknüpft.",
    deletionOutcome: "Löschergebnis",
    justification: "Begründung",
    lastUpdated: "Zuletzt aktualisiert: {{date}}",
    estimatedBeforeSave: "Geschätzt (vor Speicherung)",
    deletedCount: "{{count}} entfernt",
    notDeletedCount: "{{count}} nicht entfernbar",
    pendingCount: "{{count}} ausstehend",
    partiallyComplete: "Teilweise abgeschlossen",
    outcomePending: "Ausstehend",
    outcomeDeleted: "Entfernt",
    outcomeNotDeleted: "Nicht entfernbar",
  },
  replies: {
    professional: "Professionell",
    friendly: "Freundlich",
    serviceApology: "Service-Entschuldigung",
    waitTime: "Wartezeit",
    thankPositive: "Positive Bewertung danken",
    inviteOffline: "Offline-Gespräch anbieten",
    billingClarify: "Rechnungsklärung",
  },
  authUi: {
    brandTagline: "Steigern Sie Ihre digitale Präsenz mit Präzision.",
    gdprCompliant: "DSGVO-konform",
    sslSecure: "SSL-sicher",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinien",
    consentSuffix: "zu.",
    consentBetween: "sowie den",
  },
  platformsLoading: {
    stepAuth: "Auth",
    stepAccounts: "Konten",
    stepLocations: "Standorte",
    loadingLocations: "Standorte werden geladen",
    establishingConnection: "Verbindung wird hergestellt",
  },
  adminOutcome: {
    ariaLabel: "Löschstatus je Bewertung",
    title: "Löschstatus je Bewertung",
    hint: "Markieren Sie jede Bewertung als entfernt oder nicht entfernbar, bevor Sie den Fall abschließen.",
    markAllDeleted: "Alle als entfernt",
    markAllNotDeleted: "Alle als nicht entfernbar",
    resetAll: "Alle zurücksetzen",
    statusFor: "Status für {{author}}",
    preview: "Vorschau:",
    saveStatus: "Status speichern",
    openPlatform: "Auf {{platform}} öffnen",
    openListing: "Plattform-Eintrag öffnen",
    platformListings: "Plattform-Einträge",
  },
  adminStats: {
    total: "Gesamt",
    totalHint: "Alle Löschfälle",
    new: "Neu",
    newHint: "Letzte 7 Tage",
    pending: "Ausstehend",
    pendingHint: "Warten auf Bearbeitung",
    inProgress: "In Bearbeitung",
    inProgressHint: "Gestartet & Rechtsschritt",
    completed: "Abgeschlossen",
    completedHint: "Erfolgreich abgeschlossen",
    rejected: "Abgelehnt",
    rejectedHint: "Abgelehnte Fälle",
    newCasesWeek: "{{count}} neue Fälle in den letzten 7 Tagen",
  },
  adminUserStats: {
    sectionTitle: "Benutzer — Übersicht",
    total: "Benutzer gesamt",
    totalHint: "Alle registrierten Konten",
    new: "Neu diese Woche",
    newHint: "In den letzten 7 Tagen beigetreten",
    paid: "Professional-Konten",
    paidHint: "Aktive Professional-Abos",
    unpaid: "Free-Tier-Konten",
    unpaidHint: "Free-Tier-Kunden",
  },
  adminEmailAlerts: {
    title: "Admin-E-Mail-Benachrichtigungen",
    subtitle: "Wählen Sie, welche Plattformereignisse Ihr Admin-Team benachrichtigen.",
    newCase: "Neuer Löschfall",
    newCaseHint: "Wenn ein Kunde einen neuen Löschantrag einreicht.",
    newUser: "Neue Benutzerregistrierung",
    newUserHint: "Wenn ein neues Konto auf der Plattform erstellt wird.",
    criticalReview: "Kritische Bewertung markiert",
    criticalReviewHint: "Wenn eine 1–2-Sterne-Bewertung synchronisiert wird.",
    caseStatus: "Fallstatusänderungen",
    caseStatusHint: "Wenn ein Löschfall eine neue Bearbeitungsstufe erreicht.",
    weeklyDigest: "Wöchentliche Plattform-Zusammenfassung",
    weeklyDigestHint: "Übersicht über Fälle, Benutzer und Bewertungsaktivität.",
  },
  adminSettings: {
    title: "Admin-Einstellungen",
    subtitle: "Admin-Arbeitsbereich und Standardwerte konfigurieren.",
    workspaceTitle: "Admin-Arbeitsbereich",
    emailNotifications: "Plattform-E-Mail-Benachrichtigungen",
    emailNotificationsHint: "Admin-Warnungen bei kritischen Plattformereignissen.",
    compactTables: "Kompaktes Tabellenlayout",
    compactTablesHint: "Dichtere Zeilen in Benutzer- und Falltabellen.",
    showCasePricing: "Fallpreis-Spalten anzeigen",
    showCasePricingHint: "Abrechnungsbeträge in der Löschfall-Tabelle anzeigen.",
    confirmImpersonation: "Vor Impersonation bestätigen",
    confirmImpersonationHint: "Vor Anmeldung als Kunde nach Bestätigung fragen.",
    quickLinks: "Schnellzugriff",
    opsDocs: "Betriebsdokumentation",
    emailAlerts: "E-Mail-Benachrichtigungen",
    userManagement: "Benutzerverwaltung",
  },
  adminDocs: {
    title: "Betriebsdokumentation",
    subtitle: "Interne Anleitungen für Plattform-Administratoren.",
    featured: "Empfohlener Leitfaden",
    impersonationTitle: "Kunden-Impersonation",
    impersonationDesc:
      "Als Kunde anmelden, um Review Hub, Antworten und Plattformverbindungen zu verwalten. Ihre Admin-Sitzung bleibt im Hintergrund erhalten.",
    openUsers: "Benutzerliste öffnen",
    caseOutcomesTitle: "Fallergebnisse markieren",
    caseOutcomesDesc:
      "Jede Bewertung als entfernt oder nicht entfernbar markieren, bevor der Fall abgeschlossen wird.",
    userRolesTitle: "Rollen & Kontostatus",
    userRolesDesc:
      "Superuser können Benutzer zu Admins befördern oder Kundenkonten auf Free Tier oder Professional setzen.",
    reviewModerationTitle: "Bewertungsmoderation (alle Unternehmen)",
    reviewModerationDesc:
      "Bewertungen aller Unternehmen durchsuchen, nach Dringlichkeit filtern und zum Antworten impersonieren.",
    deletionWorkflowTitle: "Löschfall-Workflow",
    deletionWorkflowDesc:
      "Fälle von eingereicht über Rechtsschritt bis abgeschlossen oder abgelehnt bearbeiten.",
  },
  adminUserDetail: {
    backToUsers: "Zurück zu Benutzern",
    notFound: "Benutzer nicht gefunden",
    registered: "Registriert am {{date}}",
    cases: "Löschfälle",
    reviews: "Unternehmensbewertungen",
    view: "Anzeigen",
    noCompany: "Kein Unternehmen verknüpft",
    trialSection: "Kostenlose Testphase",
    trialEnds: "Testphase endet am {{date}}",
    trialExpiredOn: "Testphase endete am {{date}}",
    trialNotSet: "Kein Enddatum der Testphase gesetzt",
    trialDaysLeft: "Noch {{count}} Tag(e)",
    extendTrial: "Testphase verlängern",
    extendTrialHint:
      "Fügen Sie kostenlose Tage für diesen Kunden hinzu. Ist die Testphase abgelaufen, wird sie ab heute neu geöffnet.",
    daysLabel: "Tage hinzufügen",
    extendButton: "Um {{days}} Tage verlängern",
    extending: "Wird verlängert…",
    extendSuccess: "Testphase erfolgreich verlängert.",
    customDays: "Benutzerdefiniert",
    teamSection: "Teammitglieder",
    teamSectionHint:
      "Unterbenutzer dieses Kontos. Öffnen Sie ein Mitglied, um Aktivität einzusehen oder zu impersonieren.",
    teamEmpty: "Noch keine Teammitglieder für dieses Konto.",
    teamMemberBadge: "Unterbenutzer",
    ownerBadge: "Kontoinhaber",
    ownerOf: "Unterbenutzer von {{name}}",
    viewOwner: "Kontoinhaber anzeigen",
    openMember: "Öffnen",
    membersCount: "{{count}} Teammitglied(er)",
    joined: "Beigetreten am {{date}}",
  },
  adminUserActivity: {
    title: "Aktivität",
    subtitle: "Anmeldungen, Sicherheitsereignisse und Produktaktionen dieses Kontos.",
    filterAll: "Alle",
    filterAuth: "Auth",
    filterProduct: "Produkt",
    loading: "Aktivität wird geladen…",
    loadingMore: "Wird geladen…",
    loadMore: "Mehr laden",
    empty: "Für diesen Benutzer wurde noch keine Aktivität erfasst.",
    ip: "IP",
    actor: "Durch",
    failed: "Fehlgeschlagen",
    platform: "Plattform",
    location: "Standort",
    case: "Fall",
    events: {
      login_success: "Anmeldung erfolgreich",
      login_failed: "Anmeldung fehlgeschlagen",
      login_2fa_challenge: "2FA-Herausforderung",
      login_2fa_success: "2FA-Anmeldung erfolgreich",
      login_2fa_failed: "2FA-Anmeldung fehlgeschlagen",
      logout: "Abmeldung",
      registered: "Konto registriert",
      impersonation_started: "Impersonation gestartet",
      impersonation_stopped: "Impersonation beendet",
      case_submitted: "Löschfall eingereicht",
      ticket_created: "Support-Ticket erstellt",
      ticket_replied: "Support-Antwort",
      review_replied: "Bewertungsantwort",
      google_connected: "Google verbunden",
      google_disconnected: "Google getrennt",
      jameda_connected: "Jameda verbunden",
      jameda_disconnected: "Jameda getrennt",
      notification_prefs_updated: "E-Mail-Benachrichtigungen aktualisiert",
      role_changed: "Rolle geändert",
      account_status_changed: "Kontostatus geändert",
      trial_extended: "Testzeitraum verlängert",
      two_factor_enabled: "2FA aktiviert",
      two_factor_disabled: "2FA deaktiviert",
    },
  },
  adminTable: {
    caseId: "Fall-ID",
    user: "Benutzer",
    email: "E-Mail",
    company: "Firma",
    package: "Paket",
    violation: "Verstoß",
    reviews: "Bewertungen",
    amount: "Betrag",
    status: "Status",
    created: "Erstellt",
    actions: "Aktionen",
    name: "Name",
    registered: "Registriert",
    registerUser: "Benutzer registrieren",
    usersSubtitleExtended:
      "Alle registrierten Konten mit Suche und Filtern. Admins können sich als Kunde anmelden (Impersonation) — die Admin-Sitzung bleibt im Hintergrund erhalten. Andere Administratoren nur als Superuser.",
    clientRole: "Kunde",
    searchLabel: "Suche",
    filterSummarySearch: "Suche: „{{query}}“",
    noUsersFound: "Keine Benutzer gefunden.",
    superLabel: "Super",
    roleFor: "Rolle für {{name}}",
    accountFor: "Kontostatus für {{name}}",
    packageSubscriber: "Professional",
    packageFree: "Free Tier",
    action: "Aktion",
    expandDetails: "Details",
    collapseDetails: "Einklappen",
    statusForCase: "Status für {{caseId}}",
    manage: "Verwalten",
    submittedReviews: "Eingereichte Bewertungen ({{count}})",
    bulkSelect: "Mehrfachauswahl",
    exportDetails: "Details exportieren",
    today: "Heute",
    yesterday: "Gestern",
    daysAgo: "vor {{count}} Tagen",
  },
  dashboardBento: {
    adminHeroSubtitle:
      "Plattformweite Übersicht für Reputationsmanagement. Nutzerwachstum, aktive Fälle und operative Effizienz im Blick behalten.",
    clientHeroSubtitle:
      "Bewertungen überwachen, auf kritisches Feedback reagieren und Löschfälle von einem zentralen Dashboard aus verfolgen.",
    newThisWeekShort: "{{count}} neu diese Woche",
    newTodayShort: "{{count}} neu heute",
    criticalShort: "{{count}} kritisch",
    peak: "Spitze",
    adminNewFootnote: "Neue Registrierungen in den letzten 7 Tagen",
    userOverview: "Nutzerübersicht",
    accountOverview: "Kontoübersicht",
    growthAlert: "Wachstumshinweis",
    growthAlertMsg: "{{count}} neue Nutzer diese Woche.",
    last30Days: "Letzte 30 Tage",
    caseDistribution: "Fallverteilung",
    sentimentTrend: "Stimmungsverteilung",
    chartEmpty: "Noch keine Daten für dieses Diagramm.",
    reviewCaseAnalytics: "Bewertungen & Fälle — Analyse",
    resources: "Ressourcen",
    planStatus: "Planstatus",
    platformsConnected: "Verbundene Plattformen",
    sentimentSummary: "{{positive}} % positiv · {{negative}} % kritisch",
    adminResource1: "Empfohlener Ablauf für DSGVO-Anfragen",
    adminResource2: "Enterprise-Nutzer- & Rollenverwaltung",
    adminResource3: "SLA-Dashboard für Löschfälle",
    clientResource3: "Review Hub für alle Bewertungen öffnen",
  },
  support: {
    categoryLabel: "Worum geht es?",
    categorySupport: "Problem melden — Support-Anfrage",
    categoryFeedback: "Feedback & Wünsche zur Plattform",
    categorySupportShort: "Support",
    categoryFeedbackShort: "Feedback",
    categoryHintSupport:
      "Unser Team hilft Ihnen bei Problemen mit Bewertungen, Löschfällen oder Ihrem Konto.",
    categoryHintFeedback:
      "Sie haben eine Idee oder einen Wunsch für ReviewLytics? Wir freuen uns über jedes Feedback!",
    subjectPlaceholderFeedback: "z. B. Wunsch: Export der Bewertungen als PDF",
    messagePlaceholderFeedback:
      "Beschreiben Sie Ihre Idee oder Ihren Wunsch — was würde Ihnen die Arbeit erleichtern?",
    submitFeedback: "Feedback senden",
    feedbackSubmitted: "Feedback gesendet — vielen Dank!",
  },
  adminSupport: {
    filterAllTypes: "Alle Arten",
  },
  account: {
    enterprise: "Enterprise",
  },
  nav: {
    team: "Team",
  },
  team: {
    eyebrow: "Kontozugriff",
    title: "Team",
    subtitle:
      "Legen Sie weitere Zugänge für Ihr Team an. Team-Mitglieder sehen alle verbundenen Standorte, Bewertungen und Löschfälle Ihres Kontos.",
    addMember: "Mitglied hinzufügen",
    addTitle: "Neues Team-Mitglied",
    addHint:
      "Vergeben Sie Name, E-Mail-Adresse und ein Passwort. Das Mitglied meldet sich damit an und sieht dieselben Daten wie Sie — Abrechnung und Team-Verwaltung bleiben bei Ihnen.",
    fieldName: "Name",
    fieldNamePlaceholder: "z. B. Sabine Schmidt",
    fieldEmail: "E-Mail-Adresse",
    fieldEmailPlaceholder: "name@ihre-praxis.de",
    fieldPassword: "Passwort",
    fieldPasswordPlaceholder: "Mindestens 8 Zeichen",
    togglePassword: "Passwort anzeigen",
    createCta: "Zugang erstellen",
    creating: "Wird erstellt…",
    created: "Team-Mitglied wurde angelegt.",
    passwordShareHint:
      "Teilen Sie das Passwort persönlich mit — das Mitglied kann es danach in den Einstellungen ändern.",
    membersTitle: "Zugänge",
    memberCount: "{{count}} Personen",
    ownerBadge: "Inhaber",
    memberBadge: "Mitglied",
    joinedOn: "seit {{date}}",
    remove: "Entfernen",
    removing: "Wird entfernt…",
    removeTitle: "Team-Mitglied entfernen?",
    removeConfirm:
      "{{name}} verliert damit sofort den Zugang zu diesem Konto. Diese Aktion kann nicht rückgängig gemacht werden.",
    keepMember: "Mitglied behalten",
    removed: "{{name}} wurde entfernt.",
    empty: "Noch keine weiteren Zugänge.",
    memberViewNote:
      "Sie sind als Team-Mitglied angemeldet. Zugänge und Abrechnung verwaltet der Kontoinhaber.",
    loadError: "Team konnte nicht geladen werden.",
    errorMissing: "Bitte Name, E-Mail und Passwort ausfüllen.",
    errorEmailTaken: "Diese E-Mail-Adresse wird bereits verwendet.",
    errorWeakPassword: "Das Passwort ist zu schwach.",
    errorCreate: "Zugang konnte nicht erstellt werden.",
    errorRemove: "Mitglied konnte nicht entfernt werden.",
  },
  customOffer: {
    eyebrow: "Ihr individuelles Paket",
    ribbon: "Persönlich",
    status: {
      draft: "Entwurf",
      active: "Veröffentlicht",
      paid: "Aktiv",
      expired: "Abgelaufen",
      disabled: "Zurückgezogen",
      replaced: "Ersetzt",
      canceled: "Gekündigt",
    },
    interval: { monthly: "pro Monat", yearly: "pro Jahr", one_time: "einmalig" },
    intervalShort: { monthly: "/Monat", yearly: "/Jahr", one_time: " einmalig" },
    reference: "Angebots-Nr.",
    validUntil: "Angebot gültig bis {{date}}",
    subscribe: "Jetzt abonnieren",
    payOnce: "Jetzt bezahlen",
    redirecting: "Weiterleitung zum sicheren Checkout…",
    currentPlan: "Aktueller Tarif",
    activeSince: "Aktiv seit {{date}}",
    ownerOnly: "Nur der Kontoinhaber kann dieses Paket buchen.",
    unavailable: "Dieses Angebot ist derzeit nicht verfügbar.",
    paymentsUnavailable: "Zahlungen sind vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
    checkoutError: "Der Checkout konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
    stripeNote: "Sichere Zahlung über Stripe",
    cancelAnytime: "jederzeit kündbar",
    checkoutCancelled: "Der Checkout wurde abgebrochen — Ihr Paket steht weiterhin unten bereit.",
    supportSubject: "Anfrage: individuelles Paket",
    supportMessage:
      "Guten Tag,\n\nich interessiere mich für ein individuelles Paket. Meine Anforderungen:\n- Standorte / Plattformen: \n- Voraussichtliche Löschungen pro Monat: \n- Weitere Wünsche: \n\nVielen Dank!",
  },
  adminOffers: {
    navTitle: "Individuelle Angebote",
    eyebrow: "Vertrieb",
    title: "Individuelle Angebote",
    subtitle: "Persönliche, direkt buchbare Pakete je Kunde — erstellen, veröffentlichen, aktualisieren und nachverfolgen.",
    newOffer: "Neues Angebot",
    stats: {
      live: "Veröffentlichte Angebote",
      paid: "Bezahlte Pakete",
      withOffer: "Kunden mit Angebot",
      withoutOffer: "Kunden ohne Angebot",
    },
    tabOffers: "Angebote",
    tabCustomers: "Kunden",
    filterAll: "Alle",
    filterCurrent: "Aktiv",
    searchOffers: "Referenz, Titel, Kunde suchen…",
    searchCustomers: "Name, E-Mail, Firma suchen…",
    hasOfferAll: "Alle Kunden",
    hasOfferYes: "Mit Angebot",
    hasOfferNo: "Ohne Angebot",
    colCustomer: "Kunde",
    colPlan: "Tarif",
    colCurrentOffer: "Aktuelles Angebot",
    colActions: "Aktionen",
    colValidity: "Gültig bis",
    colUpdated: "Aktualisiert",
    noOffers: "Noch keine Angebote.",
    noCustomers: "Keine Kunden gefunden.",
    noOffer: "Kein Angebot",
    createFor: "Angebot erstellen",
    openOffer: "Angebot öffnen",
    openCustomer: "Kunde öffnen",
    edit: "Bearbeiten",
    activate: "Veröffentlichen",
    deactivate: "Zurückziehen",
    delete: "Löschen",
    confirmDelete: "Angebot wirklich löschen?",
    yes: "Ja",
    no: "Nein",
    locked: "Bezahlt — gesperrt",
    loadError: "Angebote konnten nicht geladen werden.",
    version: "v{{version}}",
    createdBy: "Erstellt von {{name}}",
    notes: "Interne Notizen",
    sentOn: "Veröffentlicht am {{date}}",
    paidOn: "Bezahlt am {{date}} · Kunde ist im Enterprise-Tarif",
    canceledOn: "Gekündigt am {{date}}",
    activated: "{{reference}} ist jetzt veröffentlicht — der Kunde wurde benachrichtigt.",
    deactivated: "{{reference}} zurückgezogen.",
    deleted: "{{reference}} gelöscht.",
    saved: "{{reference}} gespeichert.",
    created: "{{reference}} als Entwurf erstellt.",
    createdAndSent: "{{reference}} erstellt und für den Kunden veröffentlicht.",
    editor: {
      createTitle: "Neues individuelles Angebot",
      editTitle: "Angebot {{reference}} bearbeiten",
      customer: "Kunde",
      customerSearch: "Kunde nach Name, E-Mail oder Firma suchen…",
      customerHint: "Nur Kontoinhaber können ein Angebot erhalten. Team-Mitglieder sehen das Paket ihres Inhabers.",
      change: "Ändern",
      title: "Paketname",
      titlePlaceholder: "z. B. 5-Standorte-Paket",
      description: "Beschreibung",
      descriptionPlaceholder: "Wofür dieses Paket gedacht ist und was es besonders macht…",
      price: "Preis (EUR)",
      interval: "Abrechnung",
      features: "Enthaltene Leistungen",
      featurePlaceholder: "z. B. Unbegrenzte Standorte pro Plattform",
      included: "Enthalten / nicht enthalten umschalten",
      addFeature: "Leistung hinzufügen",
      limits: "Konditionen & Limits",
      limitLabel: "Bezeichnung (z. B. Löschungen / Monat)",
      limitValue: "Wert",
      addLimit: "Limit hinzufügen",
      validUntil: "Gültig bis (optional)",
      notes: "Interne Notizen (nie für den Kunden sichtbar)",
      activateNow: "Sofort veröffentlichen",
      activateHint:
        "Der Kunde wird per E-Mail benachrichtigt und sieht das Paket sofort unter „Pläne & Abrechnung“ — direkt über Stripe buchbar. Ein bestehendes veröffentlichtes Angebot dieses Kunden wird ersetzt.",
      save: "Änderungen speichern",
      create: "Als Entwurf speichern",
      createAndSend: "Erstellen & veröffentlichen",
      saving: "Wird gespeichert…",
      cancel: "Abbrechen",
      errorCustomer: "Bitte einen Kunden auswählen.",
      errorTitle: "Bitte einen Paketnamen eingeben (mind. 3 Zeichen).",
      errorPrice: "Bitte einen gültigen Preis eingeben.",
    },
    userCard: {
      title: "Individuelles Angebot",
      none: "Noch kein persönliches Paket.",
      createCta: "Angebot erstellen",
      manageCta: "Angebot verwalten",
    },
  },
  platforms: {
    locationPicker: {
      title: "Standorte auswählen",
      subtitle:
        "Dieses E-Mail-Konto ({{email}}) hat folgende zugehörige Standorte:",
      manageMenu: "Standorte verwalten",
      planHintTrial:
        "Testphase: Verbinden Sie beliebig viele Standorte — einen, mehrere oder alle.",
      planHintBasic:
        "Ihr Basic-Tarif erlaubt einen verbundenen Standort pro Plattform. Wählen Sie den Standort, der verbunden werden soll — Sie können jederzeit wechseln.",
      planHintPremium:
        "Ihr Premium-Tarif erlaubt einen verbundenen Standort pro Plattform. Wählen Sie den Standort, der verbunden werden soll — Sie können jederzeit wechseln.",
      planHintEnterprise:
        "Enterprise: Verbinden Sie beliebig viele Standorte — einen, mehrere oder alle.",
      oneAvailable: "1 Standort verfügbar",
      countAvailable: "{{count}} Standorte verfügbar",
      selectAll: "Alle auswählen",
      deselectAll: "Alle abwählen",
      connectedBadge: "Verbunden",
      reviewsMeta: "{{count}} Bewertungen",
      selectedCount: "{{count}} ausgewählt",
      noneSelected: "Kein Standort ausgewählt",
      confirmOne: "Standort verbinden",
      confirmMany: "{{count}} Standorte verbinden",
      saving: "Wird verbunden…",
      empty: "Keine Standorte gefunden",
      emptyHint:
        "Für dieses Google-Konto wurden keine Unternehmensstandorte gefunden. Prüfen Sie, ob Ihr Google Business Profil mit dieser E-Mail-Adresse verwaltet wird.",
      loadError: "Standorte konnten nicht geladen werden.",
      retry: "Erneut versuchen",
      saveError: "Auswahl konnte nicht gespeichert werden.",
      limitReached:
        "Ihr Tarif erlaubt ein verbundenes Profil pro Plattform. Um weitere Profile oder Standorte zu verbinden, kontaktieren Sie bitte den Support zu unserem Enterprise- oder Custom-Tarif.",
      notCompleted:
        "Google ist verbunden, aber es wurde noch kein Standort ausgewählt. Öffnen Sie die Standortauswahl, um die Verbindung abzuschließen.",
      upsellTitle: "Mehr als einen Standort benötigt?",
      upsellBody:
        "Ihr Tarif erlaubt ein verbundenes Profil pro Plattform. Um weitere Profile oder Standorte zu verbinden, kontaktieren Sie bitte den Support zu unserem Enterprise- oder Custom-Tarif.",
      upsellCta: "Support kontaktieren",
      enterpriseRequestSubject: "Anfrage: weitere Profile (Enterprise-/Custom-Tarif)",
      enterpriseRequestMessage:
        "Guten Tag,\n\nich möchte mehr als einen Standort verbinden (insgesamt {{count}} Standorte in meinem Google-Konto) und interessiere mich für den Enterprise- oder Custom-Tarif.\n\nBitte senden Sie mir ein Angebot mit den Konditionen.\n\nVielen Dank!",
    },
    limit: {
      message:
        "Ihr Tarif erlaubt ein verbundenes Profil pro Plattform. Um weitere Profile oder Standorte zu verbinden, kontaktieren Sie bitte den Support zu unserem Enterprise- oder Custom-Tarif.",
      eyebrow: "Tariflimit",
      title: "Ein Profil pro Plattform",
      slotUsed: "{{used}} von {{limit}} Profil-Slot belegt",
      contactSupport: "Support kontaktieren",
      manageCurrent: "Verbundenen Standort wechseln",
      badge: "Limit",
      keepThis: "Diesen Standort behalten",
      overLimitTitle: "Bitte wählen Sie das Profil, das bleiben soll",
      overLimitBody:
        "Bei {{platform}} sind {{count}} Profile verbunden, Ihr Tarif erlaubt {{limit}}. Wählen Sie eines aus — die anderen bleiben gespeichert und können später wieder verbunden werden.",
      overLimitCta: "Profil wählen",
      overLimitJamedaHint:
        "Trennen Sie die zusätzlichen Jameda-Profile über das Menü (⋮) des jeweiligen Eintrags.",
      overLimitPickerHint:
        "Es sind mehr Standorte verbunden, als Ihr Tarif erlaubt. Wählen Sie den Standort, der verbunden bleiben soll — die anderen bleiben gespeichert.",
      sidebarTitle: "Ihr Tarif",
      sidebarBody: "1 verbundenes Profil pro Plattform",
      sidebarCta: "Mehr Profile? Support kontaktieren",
      jamedaTryAnother: "Andere Business-ID verwenden",
      supportSubject: "Anfrage: weitere Profile (Enterprise-/Custom-Tarif)",
      supportMessage:
        "Guten Tag,\n\nich möchte mehr als ein {{platform}}-Profil bzw. einen Standort verbinden und interessiere mich für den Enterprise- oder Custom-Tarif.\n\nBitte senden Sie mir ein Angebot.\n\nVielen Dank!",
    },
  },
};

export default deExt;
